/* eslint-disable linebreak-style */
/* eslint-disable no-useless-escape */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

import { Bounce, Fade } from 'react-awesome-reveal';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as emailjs from '@emailjs/browser';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ToastContainer, toast } from 'react-toastify';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-toastify/dist/ReactToastify.css';

import { Form } from 'elements/Form';
import Button from 'elements/Button';
import { useNavigate } from "react-router-dom";

export const DiscussForm = (actions) => {
  const { data, resetForm } = actions;
  const navigate = useNavigate();
  const resetEmail = () => {
    resetForm();
  };

  const submitEmail = () => {
    const {
      name, company, email, phone, projectIdea,
    } = data;
  
    const templateParams = {
      from_name: `${name} - ${company} ( ${phone} - ${email} )`,
      to_name: 'MS Contractors',
      message: projectIdea,
      name: `${name}`,
      email: `${email}`,
    };
    
    if (
      name && company && email && phone && projectIdea
    ) {
      // Show loading toast or disable submit button
      toast.info('Sending your message...', { 
        position: "top-center", 
        autoClose: 5000, 
        transitio: Bounce, 
        pauseOnHover: true,
      });
      
      emailjs.send(
        'service_wbu8hyu',
        'template_i4zeqsn',
        templateParams,
        'LqjXhl-mpQg2d4SVN',
      )
        .then(() => {
          toast.success("Thank you! We'll get back to you soon. Kind Regards, Team MS!", { 
            position: "top-center", 
            autoClose: 5000, 
            transitio: Bounce, 
            pauseOnHover: true, 
          });
          resetForm();
          // Redirect to the home page after a short delay
          setTimeout(() => {
            navigate('/'); // '/' is the path to the home page
          }, 2000); // 2000ms = 2 seconds
        })
        .catch((error) => {
          console.error('Email sending error:', error);
          toast.error("An error occurred while sending your message. Please try again later.", {
            position: "top-center", 
            autoClose: 5000, 
            transitio: Bounce, 
            pauseOnHover: true,
          });
        });
    } else {
      toast.error('Please fill out the required fields correctly before submitting the form.', { 
        position: "top-center", 
        autoClose: 5000, 
        transitio: Bounce, 
        pauseOnHover: true,
      });
    }
  };

  return (
    <section className="flex flex-col container mx-auto mt-10 justify-center">

      <Fade direction="down" triggerOnce>
        <h1 className="text-5xl text-theme-blue text-center font-bold">Lets Discuss</h1>
      </Fade>

      <Fade direction="up" triggerOnce>
        <p className="font-light text-lg text-center mb-12">
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          Please fill out the form below to discuss your project and we'll get back to you in less than 24 hours.
        </p>
      </Fade>

      <Fade direction="up" triggerOnce>
        <div className="flex flex-col">
          <div className="flex flex-col sm:flex-row mx-auto">
            <Form
              id="name"
              name="name"
              type="text"
              value={data.name}
              placeholder="Your name*"
              className=""
              onChange={actions.onChange}
            />
            <Form
              id="company"
              name="company"
              type="text"
              value={data.company}
              placeholder="Your company*"
              className=""
              onChange={actions.onChange}
            />
          </div>

          <div className="flex flex-col sm:flex-row mx-auto">
            <Form
              id="email"
              name="email"
              type="email"
              value={data.email}
              placeholder="Your email address*"
              className=""
              onChange={actions.onChange}
            />
            <Form
              id="phone"
              name="phone"
              type="number"
              value={data.phone}
              placeholder="Your contact number*"
              className=""
              onChange={actions.onChange}
            />
          </div>

          <div className="mx-auto">
            <Form
              id="projectIdea"
              name="projectIdea"
              type="textarea"
              value={data.projectIdea}
              placeholder="Explain about your project idea*"
              className=""
              onChange={actions.onChange}
            />
          </div>
          <div className="flex flex-col sm:flex-row mx-auto">
          <Button
            className="text-xl mx-auto px-12 py-3 mt-5 bg-theme-purple text-white rounded-full border-2 border-theme-purple hover:bg-dark-theme-purple border-purple-800 transition duration-200 focus:outline-none sm:mr-4"
            type="button"
            onClick={resetEmail}
          >
            Clear
          </Button>
          <Button
            className="text-xl mx-auto px-12 py-3 mt-5 bg-theme-purple text-white rounded-full border-2 border-theme-purple hover:bg-dark-theme-purple border-purple-800 transition duration-200 focus:outline-none"
            type="button"
            onClick={submitEmail}
          >
            Submit
          </Button>
          </div>
        </div>
      </Fade>

      <ToastContainer />

    </section>
  );
};
